export default "__VITE_ASSET__0gNlQFZi__"